import { render } from "./AscentHeader.vue?vue&type=template&id=190f1660&scoped=true"
import script from "./AscentHeader.vue?vue&type=script&lang=js"
export * from "./AscentHeader.vue?vue&type=script&lang=js"

import "./AscentHeader.vue?vue&type=style&index=0&id=190f1660&lang=scss&scoped=true"

import exportComponent from "/var/www/ascentcontrols/landingpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190f1660"]])

export default __exports__